import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DataTypeGroupEnum} from "../../enums/dashboard/DataTypeUnitEnum";
import {MetricDataUnitEnum} from "../../enums/dashboard/MetricDataUnitEnum";
import {VirtualMetricOPEEnum} from "./VirtualMetricOPEEnum";

class O {
  metricInstances!: MetricInstanceDTO[];
}

class MetricInstanceDTO {

  partitionId!: number;

  partitionName!: string;

  id!: number;

  type!: string;

  name!: string;

  dataTypeGroup!: DataTypeGroupEnum;

  dataUnit!: MetricDataUnitEnum;

  lastValue?: any;

  lastValueTs?: any;

  constructor() {

  }
}

/**
 * O Inner Class
 */
class I {
  partitionId!: number;
}

export class GetVirtualMetricInstancesCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(VirtualMetricOPEEnum.GetVirtualMetricInstances);
    this.i = new I();
    this.o = new O();
  }
}
